<div class="header-holder">
  <div class="header">
    <div>
      <mat-icon class="logo" svgIcon="icon"></mat-icon>
    </div>

    <button [routerLink]="['/', PROFILE_PATH]" matMiniFab>A</button>

  </div>
</div>
